module.exports = __webpack_public_path__ + "img/Hungary.3596f20c.png";